const social = {
  github: 'https://github.com/eduardo-valencia',
  linkedIn: 'https://www.linkedin.com/in/eduardo-valencia-740b261b5/',
}

export default social
